import { render, staticRenderFns } from "./cRegisterDocNew.vue?vue&type=template&id=1322a00d&scoped=true"
import script from "./cRegisterDocNew.vue?vue&type=script&lang=js"
export * from "./cRegisterDocNew.vue?vue&type=script&lang=js"
import style0 from "./cRegisterDocNew.vue?vue&type=style&index=0&id=1322a00d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1322a00d",
  null
  
)

export default component.exports